import { loadStripe } from '@stripe/stripe-js';
import appConfig from './appConfig.json';

// Choose publishable key based on environment and protocol
// - Use LIVE key only on HTTPS and recognized production hosts
// - Use TEST key for localhost/LAN or any non-HTTPS environment to avoid Stripe blocking live keys
const getPublishableKey = () => {
  const win = typeof window !== 'undefined' ? window : null;
  const protocol = win?.location?.protocol || '';
  const hostname = win?.location?.hostname || '';

  // Read keys from JSON config
  const jsonLiveKey = appConfig?.stripe?.publishableKeyLive;
  const jsonTestKey = appConfig?.stripe?.publishableKeyTest;

  // Define production hosts for which LIVE is allowed (from config)
  const productionHosts = new Set(appConfig?.productionHosts || []);

  const isHttps = protocol === 'https:';
  const isProductionHost = productionHosts.has(hostname);

  if (isHttps && isProductionHost && jsonLiveKey) {
    return jsonLiveKey;
  }

  // Fallback to TEST key in all other cases
  if (jsonTestKey) {
    return jsonTestKey;
  }

  // Final fallback: keep app running without initializing Stripe to prevent runtime errors
  // Consumers should gate Stripe usage on stripePromise being non-null
  return null;
};

const STRIPE_PUBLISHABLE_KEY = getPublishableKey();

// Initialize Stripe only if we have a key
export const stripePromise = STRIPE_PUBLISHABLE_KEY ? loadStripe(STRIPE_PUBLISHABLE_KEY) : null;

// Service pricing configuration
export const SERVICE_PRICING = {
  'free-inspect-weed': {
    basePrice: 99,
    includedServices: 3,
    description: '3 services included for $99'
  },
  'flyer-1': {
    basePrice: 299,
    includedServices: 4,
    description: '4 services included for $299'
  }
};

// Calculate total price based on selected services and campaign
export const calculateServicePrice = (selectedServices, campaignType) => {
  const pricing = SERVICE_PRICING[campaignType] || SERVICE_PRICING['free-inspect-weed'];
  const basePrice = pricing.basePrice;
  const includedCount = pricing.includedServices;
  
  // Count selected services
  const selectedCount = selectedServices.length;
  
  // If more services selected than included, add $50 for each additional
  if (selectedCount > includedCount) {
    const additionalServices = selectedCount - includedCount;
    return basePrice + (additionalServices * 50);
  }
  
  return basePrice;
};
